// Solo-страница спикера для OBS (аналог vdo.ninja solo link):
// играет ТОЛЬКО трек одного участника — отдельный аудио-источник в OBS.

import { useEffect, useRef, useState } from 'preact/hooks';
import { api } from '../lib/api.js';
import { connectAsListener, type LivekitHandle } from '../lib/livekit.js';

interface ObsInfo {
  livekitUrl: string;
  livekitToken: string;
  participants: { id: number; identity: string; displayName: string }[];
}

export function ObsSpeakerPage({ episodeId, identity }: { episodeId: number; identity: string }) {
  const token = new URLSearchParams(location.search).get('token') || '';
  const [status, setStatus] = useState('подключение…');
  const [speaking, setSpeaking] = useState(false);
  const [name, setName] = useState(identity);
  const livekitRef = useRef<LivekitHandle | null>(null);

  useEffect(() => {
    document.body.style.background = '#111';
    document.body.style.color = '#eee';

    void api<ObsInfo>(`/api/obs/livekit?token=${encodeURIComponent(token)}`)
      .then(async (data) => {
        const participant = data.participants.find((p) => p.identity === identity);
        if (participant) setName(participant.displayName);
        livekitRef.current = await connectAsListener(
          data.livekitUrl,
          data.livekitToken,
          {
            onSpeakers: (ids) => setSpeaking(ids.includes(identity)),
            onConnectionState: (s) => setStatus(s === 'connected' ? 'в эфире' : s)
          },
          (id) => id === identity // играем только этот трек
        );
      })
      .catch((error) => setStatus(`ошибка: ${(error as Error).message}`));

    return () => livekitRef.current?.disconnect();
  }, [episodeId, identity, token]);

  return (
    <div style={{ padding: '24px', fontFamily: 'Inter, sans-serif' }}>
      <h1 style={{ fontSize: '28px', margin: 0 }}>
        {speaking ? '🎙 ' : ''}
        {name}
      </h1>
      <p style={{ color: '#999' }}>{status} · solo-аудио для OBS</p>
    </div>
  );
}
